import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';

dayjs.extend(customParseFormat); // need this because we receive non-standard date strings from some apis
dayjs.extend(isSameOrBefore);

type DateToParse = string | number | dayjs.Dayjs | Date | null;

export const formatDate = (formatString?: string, date = new Date()) => dayjs(date).format(formatString);
export const parseDate = (dateToParse?: DateToParse, formatString?: dayjs.OptionType) => dayjs(dateToParse, formatString).toDate();
export const addDaysToDateAndFormat = (originalDate: DateToParse, daysToAdd: number, formatString = 'MMM DD, YYYY') =>
  dayjs(originalDate).add(daysToAdd, 'day').format(formatString);
export const isTodayWithinNDaysAfterDate = (originalDate: DateToParse, nDays: number) =>
  dayjs().isSameOrBefore(dayjs(originalDate).add(nDays, 'day'));
export const extractShortMonthDayFromDate = (originalDate?: string) => {
  if (!originalDate) return;
  const parts = originalDate.split(',');
  return parts[0]?.trim();
};
export const parseDateFromMiliseconds = (originalDate: any, noYear: boolean) => {
  const date = new Date(originalDate);

  return noYear
    ? date.toLocaleDateString('en-US', {
        month: 'short',
        day: '2-digit'
      })
    : date.toLocaleDateString('en-US', {
        month: 'short',
        day: '2-digit',
        year: 'numeric'
      });
};
interface isWithinReturnWindowProps {
  orderDate: string;
  windowLength: number;
  forceStoreCreditStartDate?: boolean;
}

export const getIsWithinReturnWindow = ({ orderDate, windowLength, forceStoreCreditStartDate }: isWithinReturnWindowProps) => {
  const parsedOrderDate = dayjs(orderDate.split(' at ')[0]);
  const today = dayjs();
  const oneMonthbeforeWindowLength = today.subtract(windowLength + 30, 'day');
  const RETURN_STORE_CREDIT_START_DATE = forceStoreCreditStartDate ? oneMonthbeforeWindowLength : dayjs('2025-06-16');

  // If today is before start date, assume within window
  if (today.isBefore(RETURN_STORE_CREDIT_START_DATE)) {
    return true;
  }

  // If order date is before start date, assume within window
  if (parsedOrderDate.isBefore(RETURN_STORE_CREDIT_START_DATE)) {
    return true;
  }

  const isWithinReturnWindow = isTodayWithinNDaysAfterDate(parsedOrderDate, windowLength);
  return isWithinReturnWindow;
};
